export default __webpack_public_path__ + "static/media/fintro-logo-fr.d1623cdb.svg";